/***
 * We internally consider the field from 0 to 100;
 _______________________________________________________________________
 |      |      |      |      |      |      |      |      |      |      |
 |      |      |      |      |      |      |      |      |      |      |
 |HOME  |      |      |      |      |      |      |      |      |      |AWAY
 |      |      |      |      |      |      |      |      |      |      |
 |______|______|______|______|______|______|______|______|______|______|
 0     10     20     30     40     50     60     70     80     90     100
 */
import TeamSide from "../../football/enums/team-side";

export default class YardConverter {
    constructor(fieldLengthInYards) {
        this.fieldLengthInYards = fieldLengthInYards;
    }

    convertToFieldPosition(teamSide, yard) {
        const half = this.fieldLengthInYards / 2;
        if (yard > half) {
            return new Error("Invalid position");
        }

        return TeamSide.Visitor === teamSide
            ? this.fieldLengthInYards - yard
            : yard;
    }

    convertFromFieldPosition(fieldPosition) {
        return fieldPosition > this.fieldLengthInYards / 2
            ? {
                  teamSide: TeamSide.Visitor,
                  yard: this.fieldLengthInYards - fieldPosition
              }
            : { teamSide: TeamSide.Home, yard: fieldPosition };
    }
}
